if (!customElements.get("collection-carousel-placement")) {
  class CollectionCarouselPlacement extends HTMLElement {
    constructor() {
      super();
      this.sourceSection = null;
      this.sourceAnchor = null;
      this.placementFrame = null;
      this.recoveryFrame = null;
      this.handleResize = this.schedulePlacement.bind(this);
    }

    connectedCallback() {
      if (!this.sourceSection) {
        this.sourceSection = this.closest(".section--collection-carousel");

        if (!this.sourceSection) {
          this.remove();
          return;
        }

        this.sourceAnchor = document.createComment("collection-carousel-placement");
        this.parentNode.insertBefore(this.sourceAnchor, this);
      }

      window.addEventListener("resize", this.handleResize);
      this.schedulePlacement();
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      window.cancelAnimationFrame(this.placementFrame);

      if (!this.sourceAnchor?.isConnected) return;

      this.recoveryFrame = window.requestAnimationFrame(() => {
        if (this.isConnected || !this.sourceAnchor?.isConnected) return;

        this.classList.remove("collection-carousel-placement--embedded");
        this.sourceAnchor.parentNode.insertBefore(this, this.sourceAnchor.nextSibling);
      });
    }

    schedulePlacement() {
      window.cancelAnimationFrame(this.placementFrame);
      this.placementFrame = window.requestAnimationFrame(() => this.place());
    }

    place() {
      const productRow = Number.parseInt(this.dataset.productRow, 10);

      if (!Number.isInteger(productRow) || productRow < 1) {
        this.restoreSourcePosition();
        return;
      }

      const grid = document.querySelector(".section--collection .listing__grid");
      if (!grid) return;

      this.style.display = "none";
      const productCards = Array.from(grid.children).filter((item) =>
        item.matches("product-card"),
      );
      if (!productCards.length) {
        this.style.removeProperty("display");
        return;
      }

      const productRowTops = [
        ...new Set(productCards.map((card) => card.offsetTop)),
      ].sort((a, b) => a - b);
      const targetRowTop = productRowTops[productRow];
      const targetCard = productCards.find(
        (card) => card.offsetTop === targetRowTop,
      );
      this.style.removeProperty("display");
      const isAlreadyPlaced = targetCard
        ? this.parentNode === grid && this.nextElementSibling === targetCard
        : this.parentNode === grid && this === grid.lastElementChild;

      this.classList.add("collection-carousel-placement--embedded");

      if (!isAlreadyPlaced) {
        if (targetCard) {
          grid.insertBefore(this, targetCard);
        } else {
          grid.appendChild(this);
        }
      }

      window.requestAnimationFrame(() => {
        this.querySelector(".swiper-container")?.swiper?.update();
      });
    }

    restoreSourcePosition() {
      if (!this.sourceAnchor?.isConnected) return;

      this.classList.remove("collection-carousel-placement--embedded");

      if (
        this.parentNode !== this.sourceAnchor.parentNode ||
        this.previousSibling !== this.sourceAnchor
      ) {
        this.sourceAnchor.parentNode.insertBefore(this, this.sourceAnchor.nextSibling);
      }
    }
  }

  customElements.define(
    "collection-carousel-placement",
    CollectionCarouselPlacement,
  );
}
